import { graphql } from "@opensea/graphql"

export const SwapDetailsProviderItemFragment = graphql(`
  fragment SwapDetailsProviderItem on SwapRouteResult {
    ... on SwapRoute {
      swapProvider
    }
  }
`)
